import styled from '@emotion/styled/macro';
import { Heading, Box, Flex, Spacer } from '@chakra-ui/react';

import SearchBar from '../../components/utils/SearchBar';
import SecondaryIconButton from '../utils/SecondaryIconButton';

import { FormattedMessage } from 'react-intl';

import { ReactComponent as FilterIcon } from '../../icons/filter.svg';
import { ReactComponent as UploadIcon } from '../../icons/upload.svg';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';

const Level1AutoformHeader = ({ onChange, onFilterClick, onUploadClick, onDownloadClick, itemDescription }) => {
    return (
        <>
            <Flex pt={9} pl={6} align="center">
                <Heading as="h1" variant="h1">
                    {itemDescription}
                </Heading>
            </Flex>

            <CustomBox>
                <SearchBar onChange={onChange} />
                <ActionBar>
                    <SecondaryIconButton
                        leftIcon={<CustomFilterIcon />}
                        type="button"
                        variant="secondary"
                        onClick={onFilterClick}
                        size="sm"
                    >
                        <FormattedMessage id="common_filters_btn" />
                    </SecondaryIconButton>
                    <Spacer display={{ base: 'none', xl: 'block' }} />
                    <SecondaryIconButton
                        leftIcon={<UploadIcon />}
                        type="button"
                        variant="secondary"
                        onClick={onUploadClick}
                        size="sm"
                    >
                        <FormattedMessage id="common_upload_btn_tooltip_and_label" />
                    </SecondaryIconButton>

                    <SecondaryIconButton
                        leftIcon={<DownloadIcon />}
                        type="button"
                        variant="secondary"
                        onClick={onDownloadClick}
                        size="sm"
                    >
                        <FormattedMessage id="common_download_btn_tooltip_and_label" />
                    </SecondaryIconButton>
                </ActionBar>
            </CustomBox>
        </>
    );
};

const CustomFilterIcon = styled(FilterIcon)`
    path {
        fill: #677380;
    }
`;

const CustomBox = styled(Box)`
    display: flex;
    align-items: center;
    padding-left: 24px;

    @media (max-width: 1280px) {
        flex-wrap: wrap;
        padding-left: 24px;
        padding-right: 24px;
        flex-direction: column;
    }
`;

const ActionBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    padding: 12px 24px;
    gap: 16px;

    button {
        text-transform: capitalize;
        width: 100%;
    }

    button:first-of-type {
        margin-top: 4px;
    }

    @media (max-width: 1280px) {
        padding: 12px 0;
    }
    @media (min-width: 769px) {
        flex-direction: row;

        button:first-of-type {
            margin-top: 0px;
        }
    }

    @media (min-width: 1280px) {
        button {
            width: auto;
        }
    }
`;

export default Level1AutoformHeader;
